export const promoErrorHandler = (msg: string, t: any) => {
  const promoErrorMap: { [key: string]: string } = {
    MultipleCouponsNotAllowedToRedeem: 'promoError.MultipleCouponsNotAllowedToRedeem',
    InvalidDateRange: 'promoError.InvalidDateRange',
    CouponNotFound: 'promoError.CouponNotFound',
    CouponDisabled: 'promoError.CouponDisabled',
    CouponNotActive: 'promoError.CouponNotActive',
    CouponUsageLimitExeeded: 'promoError.CouponUsageLimitExeeded',
    FirstOrderRuleViolated: 'promoError.FirstOrderRuleViolated',
    CustomerSegmentRulesViolated: 'promoError.CustomerSegmentRulesViolated',
    'voucher.form.error.text': 'promoError.promoCodeInvalid',
  };
  return promoErrorMap[msg] ? t(promoErrorMap[msg]) : msg;
};
